import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@mui/material/Grid';

import FormRow from "../formRow";

const useStyles = makeStyles((theme) => ({
    greed: {
        marginLeft: '-4px !important',
        paddingTop: '8px'
    },
}));

const Numbers = (props) => {
  const classes = useStyles();
  const { numbers = [] } = props;

  return (
        <Grid container spacing={{xs:1, md: 3, lg :1}}  className={classes.greed}>
            <FormRow styleLaters={numbers} {...props} />
        </Grid>
  );
};

export default Numbers;
